import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";
import { OrderDisplay } from "../../Orders/UI/OrderDisplay";

export class SelectOrder extends React.Component {
  getSelectOrderColumn = (rowData, column) => {
    if (!format.isNotNull(rowData)) {
      return <div></div>;
    }
    return (
      <div>
        <pr.Button
          icon="pi pi-check"
          onClick={() => {
            this.props.selectOrder(rowData);
          }}
          style={{ float: "middle" }}
        />
      </div>
    );
  };

  getOrderColumns = () => {
    console.log(this.props);
    var allColumns = [];
    // allColumns.push(
    //   <pr.Column
    //     key="expander"
    //     expander={true}
    //     style={{ width: "5em", float: "middle" }}
    //   />
    // );
    if (format.isNotNull(this.props.orderTableColumns)) {
      let columns = this.props.orderTableColumns.map((col, i) => {
        return (
          <pr.Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filter}
            filterMatchMode={col.filterMatchMode}
            style={col.style}
          />
        );
      });

      columns.forEach(e => {
        allColumns.push(e);
      });
    }
    return allColumns;
  };

  render() {
    if (format.isNotNull(this.props.editedObject)) {
      return (
        <div className="ui-g-12 card-round">
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={() => {}}
            value={this.props.orderList}
            expandedRows={this.props.orderExpandedRows}
            onRowToggle={e =>
              this.props.updateState("orderExpandedRows", e.data)
            }
            rowExpansionTemplate={this.getOrderSelectionView}
            dataKey="id"
            emptyMessage="No Orders"
            rows={100}
            autoLayout={true}
            paginator={true}
            alwaysShowPaginator={true}
          >
            {this.getOrderColumns()}

            <pr.Column
              style={{ textAlign: "center", width: "8em" }}
              body={this.getSelectOrderColumn}
            ></pr.Column>
          </pr.DataTable>
        </div>
      );
    } else {
      console.log("Nothing to display here");
      return <React.Fragment></React.Fragment>;
    }
  }

  getOrderSelectionView = data => {
    return <OrderDisplay data={data} />;
  };
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/UI/SelectOrder.js